<template lang="pug">

form.Poppins(
    v-if="categoria && show",
    @submit.prevent="validate()",
    data-vv-name="categoria",
)
    v-card(style="background-color:#FAFAFA;box-shadow:none !important; padding-bottom: 120px;")
        v-card-title
            span.title {{ categoria.nome ? 'Editar Categoria: ' + categoria.nome : 'Cadastrar Categoria'}}
        v-card-text
            v-layout(row, wrap)
                v-flex.xs12.pb-0.mb-0
                    v-text-field.inputDefault(
                        color="gray",
                        label="Nome",
                        required,
                        v-validate="'required'",
                        :error-messages="errors.collect('nome')",
                        data-vv-name="nome",
                        type="text",
                        v-model="categoria && categoria.nome",
                        autofocus
                        outline,
                        :hide-details="false",
                        :disabled="!(editarCardapio)"
                    )
            v-layout(row, wrap, v-if="categoria.variacao == 1")
                v-flex.xs12
                    v-select.inputDefault(
                    color="gray",
                    label="Cálculo do preco",
                    item-text="nome",
                    item-value="id",
                    :items="mod_preco",
                    required,
                    v-validate="'required'",
                    :error-messages="errors.collect('mod')",
                    data-vv-name="mod",
                    data-vv-as="cálculo do preço",
                    type="text",
                    v-model="categoria.mod_preco",
                    @change="changeModPreco(categoria)",
                    outline,
                    :hide-details="true",
                    :disabled="!(editarCardapio)"
                    )
            v-layout(row, wrap, v-if="!categoria.variacao")
                v-flex.xs12
                    v-select.inputDefault(
                    color="gray",
                    label="Disponibilidade",
                    item-text="nome",
                    item-value="id",
                    :items="turnos",
                    required,
                    v-validate="'required'",
                    :error-messages="errors.collect('turnos')",
                    data-vv-name="turnos",
                    data-vv-as="disponibilidade",
                    type="text",
                    v-model="categoria.disponibilidade",
                    outline,
                    :hide-details="true",
                    :disabled="!(editarCardapio)"
                    )
            //- inativando categorias promocionais
            v-layout(row, wrap, v-if="!categoria.variacao && false")
                v-flex.md6.xs12
                    v-checkbox(
                        label="Categoria Promocional",
                        v-model="categoria.promocional",
                        :true-value="1",
                        :false-value="0",
                        color="#119a5a",

                        :disabled="!(editarCardapio)"
                    )
                v-flex.md6.xs12
                    v-text-field(
                        label="Percentual de desconto",
                        color="gray",
                        required,
                        v-validate="'required|min_value:1|max_value:100'",
                        name="desconto",
                        :error-messages="errors.collect('desconto')",
                        data-vv-name="desconto",
                        data-vv-as="percentual de desconto",
                        v-model="categoria.desconto",
                        :disabled="!categoria.promocional || !(editarCardapio)",
                        suffix="%",
                        outline,
                        :hide-details="true",
                    )
            //- inativando categorias promocionais
            v-layout(row, wrap, v-if="!categoria.variacao && false")
                v-flex.xs6
                    v-text-field(
                        type="datetime-local",
                        color="gray",
                        label="Data Inicial",
                        :disabled="!categoria.promocional || !(editarCardapio)",
                        v-model="categoria.data_inicio_desconto",
                        v-validate="'required'",
                        :error-messages="errors.collect('data_inicio_desconto')",
                        data-vv-name="data_inicio_desconto",
                        data-vv-as="data inicial",
                        required,
                        outline,
                        :hide-details="true",
                    )
                v-flex.xs6.pl-1
                    v-text-field(
                        type="datetime-local",
                        color="gray",
                        label="Data Final",
                        :disabled="!categoria.promocional || !(editarCardapio)",
                        v-model="categoria.data_fim_desconto",
                        v-validate="'required'",
                        :error-messages="errors.collect('data_fim_desconto')",
                        data-vv-name="data_fim_desconto",
                        data-vv-as="data final",
                        required
                        outline,
                        :hide-details="true",
                    )
            v-layout(row, wrap, v-if="categoria.variacao == 1")
                v-flex.xs6
                    v-text-field(
                        color="gray",
                        label="Qtd min.",
                        :disabled="categoria.mod_preco == 2 || (categoria.mod_preco == 1 && categoria.obrigatorio)",
                        required,
                        v-validate="`required|min_value:${categoria.obrigatorio ? 1 : 0}|max_value:${categoria.max}`",
                        :error-messages="errors.collect('min')",
                        data-vv-name="min",
                        data-vv-as="quantidade mínima",
                        type="number",
                        v-model="categoria.min"
                    )
                v-flex.xs6.pl-1
                    v-text-field(
                        color="gray",
                        label="Qtd max.",
                        :disabled="categoria.mod_preco == 2",
                        required,
                        v-validate="'required|min_value:1'",
                        :error-messages="errors.collect('max')",
                        data-vv-name="max",
                        data-vv-as="quantidade máxima",
                        type="number",
                        v-model="categoria.max"
                    )
                v-flex.md6.xs12.pl-1
                    v-checkbox(
                        color="accent",
                        label="Complemento obrigatório",
                        :disabled="categoria.mod_preco != 1",
                        v-model="categoria.obrigatorio",
                        :true-value="true",
                        :false-value="false",
                        @change="changeObrigatorio(categoria)"
                    )
                v-flex.md6.xs12.pl-1(v-if="categoria.mod_preco == 1 && categoria.max > 1")
                    v-checkbox(
                        color="accent",
                        label="Permitir escolha de itens repetidos",
                        v-model="categoria.repetir_itens",
                        :true-value="1",
                        :false-value="0"
                    )
        //- v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
        //-             v-card-actions.right.mb-5(v-if="(editarCardapio)")
        //-                 v-spacer(v-if="!$root.mobile")
        //-                 v-btn.btnSalvar(
        //-                     depressed,
        //-                     color="primary",
        //-                     type="submit",
        //-                     :loading="loading",
        //-                     :disabled="loading",
        //-                     ) Salvar
</template>

<script>
export default {
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        show: false,
        editarCardapio: false,
        loading: false,
        categoria: null,
        categorias: null,
        turnos: [
            { id: 3, nome: "Sempre disponível" },
            { id: 1, nome: "Disponível apenas no turno 1" },
            { id: 2, nome: "Disponível apenas no turno 2" },
        ],
    }),
    mounted() { },
    watch: {},
    methods: {
        isEditor(valor){
            this.editarCardapio = valor;
        },
        ocultarCategoria(){
            this.show = false;
        },
        open(categoria, categorias, catalogo) {
            this.show = true;
            this.categorias = categorias;

            this.categoria = categoria ? _.cloneDeep(categoria) : {
                indice: parseInt(this.categorias.length),
                ativo: 1,
                min: 0,
                max: 1,
                mod_preco: 1,
                variacao: 0,
                versao: 0,
                catalogo_id: catalogo.id,
                turno1: 1,
                turno2: 1,
                itens_repetidos: 1,
                allItens: [],
                total_itens: 0,
                pagina: 1,
                paginaCarregada: 0,
                carregando: false,
                completo: true,
                aberta: true
            };

            this.formatToOpen(this.categoria);

        },
        formatToOpen(categoria) {
            const vm = this;
            if (categoria)
                categoria.promocional =
                    categoria.data_inicio_desconto && categoria.data_fim_desconto ? 1 : 0;

            vm.categoria.desconto = vm.categoria.percentual_desconto
                ? vm.categoria.percentual_desconto * 100
                : null;

            vm.categoria.data_inicio_desconto = vm.categoria.data_inicio_desconto
                ? vm
                    .$dayjs(vm.categoria.data_inicio_desconto, "YYYY-MM-DD HH:mm:ss")
                    .format("YYYY-MM-DDThh:mm")
                : null;

            vm.categoria.data_fim_desconto = vm.categoria.data_fim_desconto
                ? vm
                    .$dayjs(vm.categoria.data_fim_desconto, "YYYY-MM-DD HH:mm:ss")
                    .format("YYYY-MM-DDThh:mm")
                : null;

            if (vm.categoria.turno1 == 1 && vm.categoria.turno2 == 1)
                vm.categoria.disponibilidade = 3;
            else if (vm.categoria.turno1 == 1 && vm.categoria.turno2 == 0)
                vm.categoria.disponibilidade = 1;
            else vm.categoria.disponibilidade = 2;

        },

        formatToSend(categoria) {
            const vm = this;
            if (categoria.promocional && (!categoria.data_inicio_desconto || !categoria.data_fim_desconto)) {
                vm.loading = false;
                return window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "É necessário informar a vigência da promoção!",
                });
            }

            if (!_.isNil(categoria.promocional) && categoria.promocional == 0) {
                categoria.percentual_desconto = 0;
                categoria.data_inicio_desconto = "NULL";
                categoria.data_fim_desconto = "NULL";
            } else {
                categoria.percentual_desconto = categoria.desconto && categoria.desconto > 1 ? categoria.desconto / 100 : categoria.percentual_desconto;
                categoria.data_inicio_desconto = categoria.data_inicio_desconto ? vm.$dayjs(categoria.data_inicio_desconto, "YYYY-MM-DDThh:mm").format("YYYY-MM-DD HH:mm:ss") : "NULL";
                categoria.data_fim_desconto = categoria.data_fim_desconto ? vm.$dayjs(categoria.data_fim_desconto, "YYYY-MM-DDThh:mm").format("YYYY-MM-DD HH:mm:ss") : "NULL";
            }
            return categoria;
        },
        async validate() {
            const vm = this;
            try {
                vm.loading = true;

                const result = await vm.$validator.validateAll('categoria');

                if (!result ) {
                  throw "Preencha todos os campos corretamente!";
                  return false;
                } else if (!vm.categoria.nome) {
                  if (!vm.categoria.nome) {
                    vm.$validator.errors.add({
                      field: 'nome',
                          msg: 'Por favor, preencha o campo Nome.'
                      });
                      return false;
                  }
                  return false;
                }
                if (vm.categoria && vm.categoria.nome && vm.categoria.nome.length > 100) {
                  vm.$validator.errors.add({
                    field: 'nome',
                        msg: 'O nome da categoria deve ter menos de 100 caracteres!'
                    });
                  return false;
                }
                vm.categoria.turno1 =
                    vm.categoria.disponibilidade == 3 ||
                        vm.categoria.disponibilidade == 1
                        ? 1
                        : 0;
                vm.categoria.turno2 =
                    vm.categoria.disponibilidade == 3 ||
                        vm.categoria.disponibilidade == 2
                        ? 1
                        : 0;

                vm.save(vm.categoria);

                vm.loading = false;
                vm.show = false;
                return true;
            } catch (error) {
              console.log(error)
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                vm.loading = false;
                return false;
            }
        },
        async save(categoria) {
            const vm = this;
            try {
                const response = await vm.$axios[categoria.id ? 'put' : 'post']("/catalogo/categoria", vm.formatToSend(categoria));

                if (categoria.id)
                    vm.categorias.map((categoria) => {
                        if (categoria.id == response.data.id)
                            categoria = _.merge(categoria, response.data);
                    });
                else {
                    const newCategory = _.merge(categoria, response.data);
                    newCategory.indice = 0;

                    // Incrementa o índice de todas as outras categorias para listar a nova categoria em primeiro, para o usuario não ter q ir até o fim da página
                    vm.categorias.forEach(categoria => categoria.indice++);
                    vm.categorias.unshift(newCategory);

                    try {
                        await vm.$axios.put('/catalogo/categoria/indice', {
                            categorias: vm.categorias,
                        });
                    } catch (err) {
                        console.error(`Erro ao atualizar o índice das categorias: ${err}`);
                    }
                }

                vm.loading = false;
                vm.$validator.reset();
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Categoria salva com sucesso!",
                });

            } catch (error) {
              console.log(error)
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao salvar a categoria. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                vm.loading = false;
            }
        }
    },
};
</script>

<style scoped>
.promocional {
    text-decoration: line-through !important;
}
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}
.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}
</style>

<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
}
</style>
